<goa-card
  class="card"
  [ngClass]="
    hearingRequest?.hearingStatusCode
      | hearingBadgeStatusColor: hearingRequest?.requestedHearingStartDate
  "
  cardSize="full"
>
  <goa-card-header>
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div fxLayout="column">
        <span
          *ngIf="
            hearingRequest?.hearingStatusCode != StatusType.AdjouredSineDie
          "
          class="status"
          [ngClass]="
            hearingRequest?.hearingStatusCode
              | hearingBadgeStatusColor
                : hearingRequest?.requestedHearingStartDate
          "
          >{{
            hearingRequest?.hearingStatusCode
              | hearingBadgeStatus: hearingRequest?.requestedHearingStartDate
          }}</span
        >
        <div
          *ngIf="
            hearingRequest?.hearingStatusCode ==
              StatusType.AdjournmentSineDiePending ||
              hearingRequest?.hearingStatusCode == StatusType.AdjouredSineDie ||
              (!hearingRequest?.requestedHearingStartDate &&
                hearingRequest?.hearingStatusCode ==
                  StatusType.AdjournmentRejected);
            else specificDate
          "
        >
          Sine Die
        </div>
        <ng-template #specificDate>
          <div
            *ngIf="
              hearingRequest?.requestedHearingStartDate;
              else emtpyHearingTime
            "
          >
            {{ hearingRequest?.requestedHearingStartDate | date: 'longDate' }}
            ({{ hearingRequest?.justice | incomplete }})
          </div>
        </ng-template>
        <ng-template #emtpyHearingTime>
          <div>Urgent</div>
        </ng-template>
      </div>
      <div>
        <div
          fxLayout="row"
          fxLayoutAlign="space-between start"
          fxLayoutGap="{{ FlexLayoutType.Gap.Small }}"
        >
          <button
            *ngIf="
              (hearingRequest?.userHearingAccess?.canAdjourn ||
                hearingRequest?.userHearingAccess?.canAdjournSineDie) &&
                showAdjournmentButton;
              else adjPendingButton
            "
            mat-stroked-button
            color="primary"
            (click)="onAdjournButtonClick(hearingRequest)"
          >
            Request Adjournment
          </button>
          <ng-template #adjPendingButton>
            <button
              *ngIf="hearingRequest?.userHearingAccess?.isAdjournmentPending"
              disabled
              mat-stroked-button
              color="primary"
            >
              Pending Adjournment
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </goa-card-header>
  <goa-card-content>
    <jsg-single-row-panel
      alignItemsH="space-between"
      alignItemsV="center"
      backgroundStyleClass="section-background-white"
    >
      <div first>
        <div>Remedy sought</div>
        <div>{{ hearingRequest?.remedySought | incomplete }}</div>
      </div>
      <div second>
        <div>Hearing time</div>
        <div
          *ngIf="hearingRequest?.requestedHearingStartDate; else noHearingTime"
        >
          <div fxLayout="row" fxLayoutGap="{{ FlexLayoutType.Gap.Small }}">
            <div>
              {{ hearingRequest?.requestedHearingStartDate | date: 'h:mm a' }} -
              {{ hearingRequest?.requestedHearingEndDate | date: 'h:mm a' }}
              ({{ hearingRequest?.duration }} minutes)
            </div>
            <div
              *ngIf="
                showCalendarButton &&
                (hearingRequest?.hearingStatusCode == StatusType.Approved ||
                  hearingRequest?.hearingStatusCode == StatusType.Submitted ||
                  hearingRequest?.hearingStatusCode ==
                    StatusType.AdjournmentPending ||
                  hearingRequest?.hearingStatusCode ==
                    StatusType.AdjournmentSineDiePending)
              "
            >
              <a routerLink="{{ calendarRoute }}{{ hearingRequest?.id }}"
                >View in calendar</a
              >
            </div>
          </div>
        </div>
        <ng-template #noHearingTime>
          <div>——</div>
        </ng-template>
      </div>
      <div third>
        <div>Request by</div>
        <div>{{ hearingRequest?.requester?.name?.firstLast | incomplete }}</div>
      </div>
      <div fourth>
        <div
          *ngIf="
            showViewDetailsButton &&
            hearingRequest?.hearingStatusCode != StatusType.AdjouredSineDie
          "
        >
          <a routerLink="{{ hearingDetailsRoute }}{{ hearingRequest?.id }}"
            >View details ></a
          >
        </div>
      </div>
    </jsg-single-row-panel>
    <ng-container *ngIf="hearingRequest | hearingComments as hearingComments">
      <jsg-single-row-panel
        *ngIf="hearingComments?.comment"
        backgroundStyleClass="comment-box"
      >
        <div first>
          <div>
            {{ hearingComments?.commentedBy }}
          </div>
          <div>
            {{ hearingComments?.comment }}
          </div>
        </div>
      </jsg-single-row-panel>
    </ng-container>

    <ng-container *ngIf="hearingRequest?.hearingHistory?.length > 0">
      <div class="mt-10">
        <jsg-action-hearing-history-view
          [hearingHistory]="hearingRequest?.hearingHistory"
          [hearingDetailsRoute]="hearingDetailsRoute"
          [expanded]="expanded"
        >
        </jsg-action-hearing-history-view>
      </div>
    </ng-container>
  </goa-card-content>
</goa-card>
